/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {CircularProgress} from '@mui/material';

const spinnerSizes = {
  xs: 16,
  sm: 20,
  md: 28,
  lg: 36,
};

type LoadingSpinnerProps = {
  size?: 'xs' | 'sm' | 'md' | 'lg';
  style?: import('@mui/system').SxProps;
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({size = 'md', style}) => {
  const spinnerSize = spinnerSizes[size];
  return <CircularProgress size={spinnerSize} sx={style} />;
};
